export default class JobStore {
  constructor() {
    this.state = {
      job: {},
    };
  }

  storeJob(job = {}) {
    this.state.job = job;
  }
}



// WEBPACK FOOTER //
// ./jobs/stores/job_store.js